import dayjs from 'dayjs';
import { useState } from 'react';

import { useUpdateAppSettings } from '~/api/user';

import { RequestAddressChangeDialog } from './RequestAddressChangeDialog';
import { VerifyAddressDialog } from './VerifyAddressDialog';

export const VerifyAddress = () => {
  const mutation = useUpdateAppSettings();

  const [isAddressCorrect, setIsAddressCorrect] = useState(true);

  const onConfirm = () => mutation.mutate({ appSettings: { addressLastVerifiedAt: dayjs().toISOString() } });
  const onReject = () => setIsAddressCorrect(false);
  const onGoBack = () => setIsAddressCorrect(true);

  return isAddressCorrect ? (
    <VerifyAddressDialog onConfirm={onConfirm} onReject={onReject} />
  ) : (
    <RequestAddressChangeDialog onConfirm={onConfirm} onGoBack={onGoBack} />
  );
};
